module.exports = __webpack_public_path__ + "img/figure02.87bebd49.png";